<template>
  <div class="text-center">
    <v-bottom-sheet v-model="visible">
      <v-sheet class="text-center" height="200px">
        <div style="position:relative;padding-top:0.8rem;">
            <span>
              <!-- <v-icon size="26" style="margin-right:3px;position:absolute;top:11px;color:#5BBAF5">mdi-shield</v-icon> -->
               <!-- style="margin-left:30px;" -->
              <span>安全验证</span>
            </span>
            <span style="position:absolute;right:10px;top:10px;"><v-icon size="27" @click="visible=false">mdi-close</v-icon></span>
        </div>
        <div style="font-size:0.85rem;padding-top:1rem;">请输入 {{ formatTel(tel) }} 收到的验证码</div>
        <div style="margin-top:0.5rem;">
            <v-row>
                <v-col :cols="8" style="padding-top:0;padding-right:0;position:relative;padding-left:5rem;">
                  <span style="position:absolute;right:10rem;top:12px;font-size:0.85rem;">验证码</span>
                  <v-text-field hide-details style="width:9rem;position:absolute;right:5px;font-size:0.95rem;" v-model="verifyCode" placeholder="请输入6位验证码" dense></v-text-field>
                </v-col>
                <v-col :cols="4" style="padding-top:0;padding-left:0rem;position:relative;">
                  <div style="font-size:0.85rem;position:absolute;top:12px;left:5px;">
                    <span v-if="!verifyCodeState" @click="sendTelVerifyCode"  style="color:#5BBAF5;">获取验证码</span>
                    <span v-else style="color:#5BBAF5;">{{codeIndate}} 秒后重发</span>
                  </div>
                </v-col>
            </v-row>
            <v-btn style="width:80%;margin-top:2.6rem;" color="#409EFF" dark @click="onSubmit" large>确定</v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      tel: '',
      verifyCode: '',
      codeIndateDef: 60,
      verifyCodeState: false,
      codeIndate: 0,
      timeout: null
    }
  },
  computed: {},
  async mounted() {
    this.init()
  },
  created() {
  },
  methods: {
    show() {
      var that = this
      that.init()
      that.visible = true
    },
    close() {
      this.visible = false
    },
    // 初始化
    async init() {
      var that = this
      that.verifyCodeState = false
      that.codeIndate = that.codeIndateDef
      that.verifyCode = ''
      var res = await that.$api.bz.getUserProfile()
      // console.log('getUserProfile.res', res);
      if (!res.success) {
        console.log('获取绑定手机号码失败', res);
        return
      }
      var data = res.data
      that.tel = data.tel;
    },
    // 手机号码格式化
    formatTel(tel) {
      if (tel === '' || !tel) {
        return
      }
      var v1 = tel.replace(/[^0-9]/ig, '')
      if (v1.length < 11) {
        return ''
      }
      var sindex = 0
      // 如果有区号或其他保留, 类似0086
      if (v1.length >= 15) {
        sindex = v1.length - 11
      }
      var ret = v1.substr(0, 3 + sindex) + '****' + v1.substr(7 + sindex)
      return ret
    },
    // 发送手机验证码
    async sendTelVerifyCode() {
      var that = this
      if (that.verifyCodeState) {
        return
      }
      if (that.tel === '') {
        that.$toast.warning('手机号码不能为空')
        return
      }
      // 请求发送手机验证码
      var res = await that.$api.bz.sendTelVerifyCode({ tel: that.tel });
      // console.log('sendTelVerifyCode.res', res);
      if (!res.success) {
        that.$toast.warning(res.error_msg)
        console.log('请求发送手机验证码失败.res', res);
        return
      }
      // 发送成功后
      that.$toast.success('发送成功')
      that.verifyCodeState = true
      that.codeIndate = that.codeIndateDef
      that.verifyDisabledTask()
    },
    // 60秒后可重新获取
    verifyDisabledTask() {
      var that = this
      if (that.timeout) {
        window.clearTimeout(that.timeout)
      }
      that.codeIndate--
      if (that.codeIndate <= 0) {
        that.verifyCodeState = false
        // console.log('可重新获取验证码.');
        return
      }
      that.timeout = setTimeout(that.verifyDisabledTask, 1 * 1000)
    },
    // 确定提交
    async onSubmit() {
      var that = this
      if (!that.verifyCode || that.verifyCode === '') {
        that.$toast.warning('请输入6位验证码')
        return
      }
      if (that.verifyCode.length !== 6) {
        that.$toast.warning('请输入正确验证码')
        return
      }
      var res = await that.$api.bz.checkTelVerifyCode({ tel: that.tel, verify_code: that.verifyCode })
      // console.log('checkTelVerifyCode.res', res)
      if (!res.success) {
        that.$toast.warning(res.error_msg)
        return
      }
      // 安全验证通过
      that.$emit('verifyed')
      that.close()
    }
  }
}
</script>

<style scoped>
</style>

